/* eslint-disable react/no-unescaped-entities */

import { Meta } from '@/layout/Meta'
import { PaymentPage } from '@/templates/PaymentPage'
import { useEffect } from 'react'
import { note } from '@/utils/Note'

const Checkout = () => {
  useEffect(() => {
    note('Visited Checkout')
  }, [])
  
  return (
    <PaymentPage meta={<Meta 
        title="Pay Now"
        description="Checkout" />}>
          &nbsp;
    </PaymentPage>
  )
}

export default Checkout
